import { gql, useQuery } from "@apollo/client";
import { simplifiedAdOperationQuery, SimplifiedAdOperation } from "__generated__/api";
import FetchSimplifiedAd = SimplifiedAdOperation.Query;

const simplifiedAdOperation = gql`
  ${simplifiedAdOperationQuery}
`;

export function useSimplifiedAdOperationQuery(variables: SimplifiedAdOperation.Variables) {
  return useQuery<FetchSimplifiedAd>(simplifiedAdOperation, {
    variables,
    ssr: false,
    fetchPolicy: "no-cache",
  });
}

export default useSimplifiedAdOperationQuery;
